<template>
  <div class="base-module">
    <!-- 概览 -->
    <member-module :data="data && data.info" />
    <my-form :data="data" />
  </div>
</template>

<script>
import MemberModule from './MemberInfo'
import MyForm from './Form'

export default {
  components: {
    MemberModule,
    MyForm
  },
  props: {
    data: {
      type: Object,
      default: () => { }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
